import { SmartRouterServiceAbstract } from '@cronos-app/swap-sdk';
import { smartRouterFetcher } from '../fetchers/smartRouterFetcher';
import { toWrappedTokenFactory } from '../utils/toWrappedTokenFactory';
export class SmartRouterService extends SmartRouterServiceAbstract {
    constructor(chainId, clientId) {
        super();
        this.chainId = chainId;
        this.clientId = clientId;
        this.toWrappedToken = toWrappedTokenFactory(this.chainId);
        this.getBestAMMTrade = (opts) => smartRouterFetcher(this.chainId, this.clientId, opts);
    }
}
